import { SectionSeparator } from "../../atom/SectionSeparator";
import { StartingCard } from "../dashboard/main/exam/StartingCard";
import React from "react";
import { useTranslation } from "react-i18next";
import { ParticipantExam } from "../../../types/components";
import { NoExams } from "../../molecules/exam/NoExams";
import { useUserContext } from "../../../utils/contexts/UserProvider";
import { getResponsiblePersons } from "../../../utils/exam";

interface OtherUpcomingExamsProps {
  data?: ParticipantExam["exam"][] | null;
  mutateEnrolledExams: () => void;
  mutateUpcomingExams: () => void;
}

export const OtherUpcomingExams: React.FC<OtherUpcomingExamsProps> = ({
  data,
  mutateUpcomingExams,
  mutateEnrolledExams,
}) => {
  const { t } = useTranslation();
  const { user, setUser } = useUserContext();

  const noExams = !data?.[0];
  return (
    <div className="px-[52px] mt-[80px] pt-8 pb-10 flex flex-col gap-14">
      <SectionSeparator label={t("Other upcoming exams")} type="secondary" />

      <div className={`grid gap-10 ${noExams ? "grid-cols-1" : "grid-cols-2"}`}>
        {noExams && <NoExams label="No upcoming exams." />}
        {data?.map(
          ({
            id,
            responsible_persons,
            code,
            exam_type,
            questions_number,
            date_from,
            is_finished,
            date_to,
            seconds_until_start,
            seconds_until_end,
          }) => {
            const authorizedPerson = getResponsiblePersons(responsible_persons);

            return (
              <StartingCard
                key={id}
                id={id}
                title={code}
                type={exam_type.name}
                questions={questions_number}
                authorizedPerson={authorizedPerson}
                startDate={date_from}
                is_completed={true}
                is_finished={is_finished}
                endDate={date_to}
                isEnroll
                enrollDisabled={user?.is_enrolled}
                secondsUntilStart={seconds_until_start}
                secondsUntilEnd={seconds_until_end}
                handleOnEnroll={() => {
                  setUser((prev) => (prev ? { ...prev, is_enrolled: true } : null));
                  mutateEnrolledExams();
                  mutateUpcomingExams();
                }}
              />
            );
          },
        )}
      </div>
    </div>
  );
};
